/**
 * The course's sessions as a calendar a person subscribes to, as its own Task
 * in place (O1): create an address, replace it, or stop sharing it. IMAM
 * publishes; the calendar app reads; nothing comes back. The address appears
 * only in the create response, held in this component's state and nowhere
 * else, and is shown once.
 *
 * c2's answers: GET says none, active or stopped and never the address; a
 * 404 means this seat holds no place on the course. A re-create replaces the
 * address atomically. Stop is idempotent. After a lost answer the result is
 * unknown: read the state first and act on it.
 */

import { Bento } from "@/components/ui/box";
import { useCalendarBox } from "./use-calendar-box";

/**
 * The calendar Task in its own Bento, beside the plan it subscribes to; nothing for a seat the course refuses.
 * Keyed by course, so a one-time address, a choice or a late answer never crosses into another course.
 */
export function CalendarSubscriptionFrame({ courseId }: { courseId: string; teaching?: boolean }) {
  return <CalendarTask key={courseId} courseId={courseId} />;
}

function CalendarTask({ courseId }: { courseId: string }) {
  const box = useCalendarBox(courseId);
  if (box.read.status === "forbidden") return null;
  return <Bento id="course-calendar" journey="course-calendar" boxes={[box]} />;
}
